import { Dispatch, SetStateAction } from 'react';
import { Grid } from '@mui/material';
import IncidentDetailItem from './IncidentDetailItem';
import { OperationIncident } from '@networkRequest/operationsService';
import OperationOfficialAvatar from '@pages/Operations/components/OperationOfficialAvatar';

const IncidentPersonnel = ({
  incident,
  setEditPersonnelOpen,
}: {
  incident: OperationIncident;
  setEditPersonnelOpen: Dispatch<SetStateAction<boolean>>;
}) => {
  return (
    <IncidentDetailItem
      name='Personnel'
      onClick={() => setEditPersonnelOpen(true)}
    >
      <Grid container spacing={1} sx={{
        mt: '4px'
      }}>
        {incident.officials?.map(({ agency_official }) => {
          return (
            <OperationOfficialAvatar
              key={agency_official.id}
              agency_official={agency_official}
              variant='light'
            />
          );
        })}
      </Grid>
    </IncidentDetailItem>
  );
};

export default IncidentPersonnel;